import styled from '@emotion/styled'

import { mediaQuery } from '~/@common/styles/mediaQuery'

export const S = {
  Root: styled.div`
    width: 100%;
    border-radius: 4px;
    overflow: hidden;

    .header {
      background: var(--Colors-Blue-600);
      height: 64px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 17px 20px;
    }

    .nav-btn {
      display: flex;
      align-items: center;
      gap: 4px;
      color: var(--White);
      font-size: 14px;
      font-weight: 700;
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
    }

    .month-btn {
      display: flex;
      align-items: center;
      gap: 7px;
      color: var(--White);
      font-size: 20px;
      font-weight: 700;
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;

      .chevron-icon {
        transition: transform 0.15s;

        &.open {
          transform: rotate(180deg);
        }
      }
    }

    .body {
      border: 1px solid var(--Colors-Gray-400);
      border-top: none;
      border-radius: 0 0 4px 4px;
      background: var(--White);
    }

    .week-list {
      padding: 16px 16px 0;
      display: flex;
      flex-direction: column;
      gap: 4px;
      height: 256px;
    }

    .week-item {
      flex: 1 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 16px;
      border-radius: 4px;
      border: none;
      cursor: pointer;
      width: 100%;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      background: var(--White);
      color: var(--Colors-Gray-900);

      &.selected {
        background: var(--Colors-Blue-600);
        color: var(--White);
        font-weight: 700;
      }

      &:not(.selected):not(:disabled):hover {
        background: var(--Colors-Gray-100);
      }

      &:disabled {
        color: var(--Colors-Gray-500);
        cursor: default;
        background: var(--White);
      }

      ${mediaQuery.underTablet} {
        padding: 8px 0;
      }
    }

    .note {
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
      color: var(--Colors-Gray-500);
      padding: 8px 16px 12px;

      ${mediaQuery.underTablet} {
        .note-standard {
          display: none;
        }
      }
    }

    .picker {
      display: flex;
      height: 311px;
      padding: 0 16px;
      gap: 4px;
    }

    .picker-column {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      padding: 16px 0;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .picker-item {
      height: 40px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      border: none;
      cursor: pointer;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      background: var(--White);
      color: var(--Colors-Gray-900);

      &.selected {
        background: var(--Colors-Blue-600);
        color: var(--White);
        font-weight: 700;
      }
    }
  `,
}
